export default __webpack_public_path__ + "static/media/859.8e09f683.png";